import angular from 'angular';
import FeaturedSliderComponent from './featured-slider.component';

let FeaturedSliderModule = angular.module('home.featuredSlider', [])
    .component('featuredSlider', FeaturedSliderComponent);

export default FeaturedSliderModule;



/** WEBPACK FOOTER **
 ** ./www/components/home/featured-slider/featured-slider.js
 **/